import script from "./CheckRebateSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckRebateSetting.vue?vue&type=script&setup=true&lang=ts"

import "./CheckRebateSetting.vue?vue&type=style&index=0&id=b4125d5a&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4125d5a"]])

export default __exports__